module.exports = __webpack_public_path__ + "static/img/pic-04@2x.9749977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-04@2x.png
// module id = dWG8
// module chunks = 1